/**
 * Consumer-facing money format used across the paywall UI: symbol-first,
 * currency-disambiguated, and no trailing ".00" on whole amounts.
 *   formatMoney(5, 'usd')      -> "US$5"
 *   formatMoney(4.99, 'usd')   -> "US$4.99"
 *   formatMoney(20, 'eur')     -> "€20"
 *   formatMoney(500, 'jpy')    -> "¥500"
 *
 * en-GB renders foreign dollars as US$/CA$/A$ (avoids the ambiguous bare "$")
 * while keeping native €/£/¥. Mirrors the paywall backend's terms() formatting.
 */
export function formatMoney(amount, currency) {
  const n = Number(amount) || 0
  const code = String(currency || 'USD').toUpperCase()
  const whole = Number.isInteger(n)
  try {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: code,
      currencyDisplay: 'symbol',
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(n)
  } catch (e) {
    return `${whole ? n : n.toFixed(2)} ${code}`
  }
}
